import { format } from 'date-fns'

interface Props {
  date: string | null | undefined
  fmt?: string
}

export function FormattedDate({ date, fmt = 'MMM d, yyyy' }: Props) {
  if (!date) return <>{'—'}</>
  try {
    return <>{format(new Date(date), fmt)}</>
  } catch {
    return <>{date}</>
  }
}
